<template>
    <div>
        <div class="row data-form">
            <div class="col-12 col-md-12">
                <ValidationObserver ref="updateForm">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <ValidationProvider name="student_club_id" rules="" v-slot="{ valid, errors }">
                                <b-form-group :label="$t('club')">
                                    <student-club-selectbox v-model="defineForm.student_club_id"/>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                            <ValidationProvider name="file" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('excel_file')">
                                    <div class="d-flex custom-file-upload">
                                        <b-form-file v-model="defineForm.file"
                                                     :state="errors[0] ? false : (valid ? true : null)"
                                                     :placeholder="$t('select_file')"
                                                     :drop-placeholder="$t('drop_file')"
                                                     ref="fileInput"
                                                     multiple
                                        />
                                        <b-button variant="outline-secondary"
                                                  @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                        </b-button>
                                    </div>
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
<!--                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <b-form-group :label="$t('excel_format')">
                                <div class="alert alert-info">
                                    {{ $t('course_schedule_format') }}
                                </div>
                            </b-form-group>
                        </div>-->
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 d-flex">
                            <b-button @click="download('student_club_students_import')" variant="outline-secondary" class="mr-2">{{ $t('download_excel_template') }}</b-button>
                            <b-button variant="primary"
                                      @click="sendForm"
                                      label="import"
                            />
                        </div>
                    </div>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>
<script>
// Component

// Services
import StudentClubMemberSearch from '@/services/StudentClubMemberSearch';

// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import excelImportTemplate from "@/services/ExcelImportTemplate";
import StudentClubSelectbox from "@/components/interactive-fields/StudentClubSelectbox.vue";

export default {
    components: {
        StudentClubSelectbox,
        ValidationProvider,
        ValidationObserver
    }
    ,
    data() {
        return {
            defineForm: {
                file: null,
                student_club_id: null
            },
            loading: false,
            options: [],
        }
    }
    ,
    methods: {
        async sendForm() {
             const isValid = await this.$refs.updateForm.validate();
             if (isValid) {
                 let formData = new FormData();
                 formData.append('file', this.defineForm.file[0])
                 formData.append('student_club_id',this.defineForm.student_club_id)

                 return StudentClubMemberSearch.fileImport(formData)
                     .then(response => {
                         this.$toast.success(this.$t('api.' + response.data.message));
                         this.$emit('onError', response)
                     })
                     .catch(e => {
                         this.showErrors(e,this.$refs.updateForm)
                     })
             }
        },
        download(code) {
            excelImportTemplate.downloadTemplate(code)
                .then(response => {
                    this._downloadFile(response, code + '.xlsx')
                })
                .catch(error => {
                    if (error.status == 422) {
                        this.$toast.error(error.data.errors.file[0]);
                    }
                    if (error.status == 406) {
                        this.$toast.error(this.$t('api.' + error.data.message));
                    }
                });
        },
    }
}
</script>
